import pageNotFound from '../../assets/img/Error404.pageNotFound.png';
import serverError from '../../assets/img/Error500.serverError.png';
import forbidden from '../../assets/img/Error403.forbidden.png';
import noInternetConection from '../../assets/img/Error.noInternetConection.png';
import noResults from '../../assets/img/noResults.png';

export const statusImg: { [key: string]: string } = {
  PAGE_NOT_FOUND: pageNotFound,
  SERVER_ERROR: serverError,
  FORBIDDEN: forbidden,
  NO_INTERNET_CONECTION: noInternetConection,
  NO_RESULTS: noResults
};

export default statusImg
